<template>
    <v-container>
        <p style="display: none;">{{line_id}}</p>
        

        <div v-if="needReload">
            <v-row  >
            <v-col cols="12" sm="12">
                <v-btn color="success" @click="get_sub_liff_status" large block style="font-weight:bold; font-size: 20px">重新整理</v-btn>
            </v-col>
        </v-row>
        </div>

        <div v-else>

            <v-row>
                <v-col cols="12">
                    <div style="text-align: center; font-size: 18px;">
                        <h3>點擊下方 『開始訂閱』之後，<br/>請選擇:</h3>
                    </div>
                </v-col>
            </v-row>
            
            <v-row align="center">
                <div>
                    <img src="../../assets/connect_1on1N.png" width="100%"/>
                </div>
            </v-row>

            <!-- {{sub_liff}} -->

            <v-row justify="center" v-if="state">
                <v-col cols="6" sm="6">
                    <v-btn color="success" @click="go_sub" large block :disabled="link_status" style="font-weight:bold; font-size: 20px">開始訂閱</v-btn>
                </v-col>
                <v-col cols="6" sm="6">
                    <v-btn color="error" @click="cancel_sub" large block :disabled="!link_status" style="font-weight:bold; font-size: 20px">取消訂閱</v-btn>
                </v-col>
            </v-row>

            <v-row v-else>
                <v-col cols="12">
                    <div style="text-align: center; font-size: 18px;">
                        <h3>狀態讀取中，請稍候...</h3>
                    </div>
                </v-col>
            </v-row>

        </div>

    </v-container>
</template>


<script>
import bus from '../nav/bus'
let lambda_url = process.env.VUE_APP_HOST_URL

export default {
    data() {
        return {
            state: false,
            needReload: false,
            sub_liff: "",
            co: "",
            link_status: false,
            line_id: -1
        }
    },
    created(){
        // console.log(this.$route.query.liff.state)
        console.log('xxx')
    },
    mounted(){
        if(this.$route.query.lid == undefined){
            this.co = this.$route.query.co

            // let lid = this.$route.query['liff.state'].split('lid=')[1]
            
            let sp = new URLSearchParams(this.$route.query['liff.state'].split('?')[1])
            console.log(sp);
            let lid = sp.get('lid');

            this.initializeLiff(lid)
            return
        }
        else{
            let lid = this.$route.query['lid']
            this.co = this.$route.query['pars']
            this.initializeLiff(lid, true)
        }
    },
    methods: {
        initializeLiff(myLiffId, isSecond=false) {
            liff.init({
                    liffId: myLiffId
                })
                .then(() => {
                    if (!liff.isLoggedIn()) {
                        liff.login({
                            redirectUri: location.href
                        });
                        return;
                    }
                    var context = liff.getContext();
                    this.line_id = context.userId
                    if(isSecond)
                        this.get_sub_liff_status()
                })
                .catch((err) => {
                });
        },
        go_sub(){
            
            // try {
            //     liff.openWindow({
            //         // url: decodeURI(target),
            //             url: this.sub_liff,
            //         external: false
            //     });
            // } catch {
            //     alert("use window.open")
            //     window.open(this.sub_liff);
            // }
            // alert('use location.href')
            // location.href = this.sub_liff;
            window.open(this.sub_liff);
        },
        cancel_sub(){
            let post_data = {
                pars: this.co,
                line_id: this.line_id,
            }

            axios.post(lambda_url+'/notify_cancel_sub', post_data)
            .then(response => {
                var tmp = response.data
                console.log(tmp)
                if(tmp.status === true){
                    alert('取消訂閱成功')
                    this.link_status = !this.link_status
                }
                else
                    alert(tmp.msg)
            })
            .catch((error)=> {
            	alert(error)
                console.log(error);
            });
        },
        get_sub_liff_status(){
            this.needReload = false;
            let post_data = {
                pars: this.co,
                line_id: this.line_id,
            }

            axios.post(lambda_url+'/notify_get_sub_liff_status', post_data)
            .then(response => {
                var tmp = response.data
                if(tmp.status == true){
                    this.state = true
                    this.link_status = tmp.link_status
                    this.sub_liff = tmp.sub_liff
                }
                else{
                    if(tmp.robot_id != null){
                        alert('請先加機器人為朋友唷! 加入後請重新開啟~')
                        this.needReload = true;
                        document.location.href="line://ti/p/"+tmp.robot_id
                    }
                }
            })
            .catch((error)=> {
                alert('IN get_sub_liff_status~ Error')
            	alert(error)
                console.log(error);
            });
        },
    },
}
</script>